const translations = {
  "en": {
    "View More": "View More"
  },
  "zh-tw": {
    "View More": "查看更多"
  }
};

export default translations;
